import { required } from "vuelidate/lib/validators";

export default class AmbienteData {
  id = null;
  nome = "";
  descricao = "";
  ativo = true;

  constructor({ id = null, nome = "", descricao = "", ativo = true } = {}) {
    this.id = id;
    this.nome = nome;
    this.descricao = descricao || "";
    this.ativo = ativo;
  }
}

export const AmbienteDataRequired = {
  nome: {
    required,
  },
};
